import React from 'react'
import './gallery.css';
import img1 from '../../assets/Gallery/img1.jpg';
import img2 from '../../assets/Gallery/img2.JPG';
import img3 from '../../assets/Gallery/img3.jpg';
import img4 from '../../assets/Gallery/img4.jpg';
import img5 from '../../assets/Gallery/img5.JPG';
import img6 from '../../assets/Gallery/img6.jpg';
import img7 from '../../assets/Gallery/img7.jpg';
import img8 from '../../assets/Gallery/img8.JPG';
import img9 from '../../assets/Gallery/img9.jpg';
import img10 from '../../assets/Gallery/img10.jpg';


const Gallery = () => {
  return (
    <div>
      <div className="gallery">
        <h2>Gallery</h2>
        <div class="gallery-imgs">
          <img src={img1} alt="" />
          <img src={img2} alt="" />
          <img src={img3} alt="" />
          <img src={img4} alt="" />
          <img src={img5} alt="" />
          <img src={img6} alt="" />
          <img src={img7} alt="" />
          <img src={img8} alt="" />
          <img src={img9} alt="" />
          <img src={img10} alt="" />
        </div>
      </div>
    </div>
  )
}

export default Gallery